export default new window.google.maps.LatLngBounds(
    new window.google.maps.LatLng(53.31, 14.40),
    new window.google.maps.LatLng(53.53, 14.72)
);
